import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { boldTypes, TypographyType } from '@custom-types/TypographyTypes';
import { styled, Typography, TypographyProps } from '@mui/material';

type StyledTypographyProps = TypographyProps & {
  typographyType: TypographyType;
  color?: string;
};

const typographyMap: Record<string, { fontSize: string; lineHeight: string }> = {
  display: { fontSize: '3rem', lineHeight: '4.1875rem' },
  pageTitle: { fontSize: '1.5rem', lineHeight: '2.25rem' },
  pageTitleBold: { fontSize: '1.5rem', lineHeight: '2.25rem' },
  pageSubtitleMD: { fontSize: '1rem', lineHeight: '1.5rem' },
  pageSubtitleMDBold: { fontSize: '1rem', lineHeight: '1.5rem' },
  pageSubtitleSM: { fontSize: '0.875rem', lineHeight: '1.3125rem' },
  pageSubtitleSMBold: { fontSize: '0.875rem', lineHeight: '1.3125rem' },
  sectionTitleMD: { fontSize: '1.125rem', lineHeight: '1.6875rem' },
  sectionTitleMDBold: { fontSize: '1.125rem', lineHeight: '1.6875rem' },
  sectionTitleSM: { fontSize: '1rem', lineHeight: '1.5rem' },
  sectionTitleSMBold: { fontSize: '1rem', lineHeight: '1.5rem' },
  bodyTextLG: { fontSize: '1.125rem', lineHeight: '1.6875rem' },
  bodyTextLGBold: { fontSize: '1.125rem', lineHeight: '1.6875rem' },
  bodyTextMD: { fontSize: '1rem', lineHeight: '1.5rem' },
  bodyTextMDBold: { fontSize: '1rem', lineHeight: '1.5rem' },
  bodyTextSM: { fontSize: '0.875rem', lineHeight: '1.3125rem' },
  bodyTextSMBold: { fontSize: '0.875rem', lineHeight: '1.3125rem' },
  labelLG: { fontSize: '1rem', lineHeight: '1.5rem' },
  labelLGBold: { fontSize: '1rem', lineHeight: '1.5rem' },
  labelMD: { fontSize: '0.875rem', lineHeight: '1.3125rem' },
  labelMDBold: { fontSize: '0.875rem', lineHeight: '1.3125rem' },
  labelSM: { fontSize: '0.75rem', lineHeight: '1.125rem' },
  labelSMBold: { fontSize: '0.75rem', lineHeight: '1.125rem' },
  buttonTextLG: { fontSize: '1.125rem', lineHeight: '1.5rem' },
  buttonTextMD: { fontSize: '1rem', lineHeight: '1.25rem' },
  buttonTextSM: { fontSize: '0.875rem', lineHeight: '1.125rem' },
};

const TypographyTsoPq = styled(Typography, {
  shouldForwardProp: (prop) => !['typographyType', 'lineHeightType', 'color'].includes(prop as string),
})<StyledTypographyProps>(({ typographyType, color }) => {
  return {
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: typographyMap[typographyType].fontSize,
    fontWeight: boldTypes.has(typographyType) ? 700 : 400,
    fontStyle: 'normal',
    color: color ?? tsoPqTheme.palette.customTextColor.color_font_ft_text,
    lineHeight: typographyMap[typographyType].lineHeight,
    whiteSpace: 'pre-line',
  };
});

export default TypographyTsoPq;
